<template>
  <div>
    <div class="plus"><img src='../assets/img/addPerson.png' @click="goYsg()"></div>      
    <div class='top'>信息列表</div>
    <div class="loading" v-if="showLoading">
      <van-loading type="spinner" />数据加载中...
    </div>
    <div class='record' ref="list" id="list">
      <div v-for='(item, index) in recordList.list' :key='index' class='record-list-item'>
        <div>{{ item.name }}</div>
        <div class='big-item'>{{ item.schoolName }}</div>
        <div @click="goRecord(item)" class="link">查看</div>
      </div>
    </div>
    <div class='r-query' @click='goQuery'>
      <button class="btn">通过 姓名+身份证/电话/学号 查询</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "list",
  data() {
    return {
      showLoading: 1,
      recordList: { list: '' },
      page: 1,
      isLoad: false,
      openId: ''
    };
  },
  mounted() {
    /* if (wstToken!=null && wstToken!=''){
       this.$router.push(`/query?wstToken=${wstToken}`);
     } */
    /**
     * 获取openId
    */
    let _this = this;
    _this.openId = _this.$route.query.openId;

    _this.getTitle();
    _this.getData(_this.openId);

    window.addEventListener('scroll', function () {
      let scroll = document.documentElement.scrollTop || document.body.scrollTop
      let winHeight = document.body.clientHeight && document.documentElement.clientHeight
      if (_this.$refs.list != null) {
        let listHeight = _this.$refs.list.offsetHeight
        if (scroll >= listHeight - winHeight - 80) {
          _this.page++;
          _this.getData(_this.openId);
        }
      }
    })

  },
  methods: {
    /**
     * 获取数据
    */
    async getData(openId) {
      let auth = this.$createAuth(this.$md5);
      let _this = this;
      if (!this.isLoad) {
        this.isLoad = true;
        let hospitalId = this.$route.query.hospitalId;
        if (hospitalId == null || typeof (hospitalId) == undefined) hospitalId = '';
        let result = await this.$http.get(this.$url.relatedStudents, {
          openId: openId,
          page: this.page,
          hospitalId: hospitalId,
          pageSize: 30,
          auth: auth.code,
          time: auth.time
        });
        if (result.message === 'Error: Miss auth parameter.') {
          setTimeout(function () {
            _this.showLoading = 0;
            _this.isLoad = false; _this.getData(openId);
          }, 500);
        } else {
          this.showLoading = 0;
          let searchResultList = [...this.recordList.list, ...result.data.studentList.list]
          this.recordList.list = searchResultList;
          this.isLoad = false;
        }
      }
    },
    /**
     * 跳转记录页面
    */

    async goRecord(item) {
      let auth = this.$createAuth(this.$md5);
      let sid = item.uid;
      let hospitalId = this.$route.query.hospitalId;
      if (hospitalId == null || typeof (hospitalId) == undefined) hospitalId = '';
      let result = await this.$http.get(this.$url.checkList, {
        openId: this.openId, studentId: sid,
        auth: auth.code,
        time: auth.time
      });
      if (result.message === 'Error: Miss auth parameter.') {
        this.goRecord(item);
      } else {
        let list = result.data.chekList;
        /* if(list.length==1){
          let item = list[0];
          if(item.screenType == 0){
            hospitalId = item.hospitalId;
            if(hospitalId==null || typeof(hospitalId)==undefined) hospitalId='';
            let sid = item.uid;
            let activityId = item.activityId
            if (typeof(activityId) == "undefined") activityId=''
            this.$router.push(`/detail?sid=${sid}&screenType=${item.screenType}&activityId=${activityId}&openId=${this.$route.query.openId}&hospitalId=${hospitalId}&tuid=${item.studentId}`);
          }else{
            this.$router.push(`/record?cname=${item.clazzName}&tid=${item.archives_no}&sid=${sid}&openId=${this.$route.query.openId}&hospitalId=${hospitalId}`);
          }
        }else{*/
        /* this.$router.push(`/record?cname=${item.clazzName}&tid=${item.archives_no}&sid=${sid}&openId=${this.$route.query.openId}&hospitalId=${hospitalId}&studentIds=${item.studentIds}`);*/
        // }

        try {
          let result2 = await this.$http.get(this.$url.checkPhone, {
            studentId: item.student_id
          });
          if (!result2.result) {
            if (list.length == 1) {
              let item1 = list[0];
              hospitalId = item1.hospitalId;
              if (hospitalId == null || typeof (hospitalId) == undefined) hospitalId = '';
              let sid = item1.uid;
              let activityId = item1.activityId
              if (typeof (activityId) == "undefined" || !activityId) activityId = ''
              this.$router.push(`/record?sid=${sid}&screenType=${item1.screenType}&activityId=${activityId}&openId=${this.$route.query.openId}&hospitalId=${hospitalId}&tuid=${item1.studentId}&isOne=1`);
            } else {
              this.$router.push(`/record?cname=${item.clazzName}&tid=${item.archives_no}&sid=${sid}&openId=${this.$route.query.openId}&hospitalId=${hospitalId}&studentIds=${item.studentIds}`);
            }
          } else {
            this.$router.push(`/setPhone?cname=${item.clazzName}&tid=${item.archives_no}&sid=${sid}&openId=${this.$route.query.openId}&hospitalId=${hospitalId}&student_id=${item.student_id}&studentIds=${item.studentIds}`);
          }
        } catch (err) {
          this.$router.push(`/record?cname=${item.clazzName}&tid=${item.archives_no}&sid=${sid}&openId=${this.$route.query.openId}&hospitalId=${hospitalId}&studentIds=${item.studentIds}`);
        }
      }
    },
    async getTitle() {
      let openTitle = []
      let openTitleStr = localStorage.getItem("openTitle");
      let title = '';
      if (openTitleStr && openTitleStr != 'null'){
        openTitle = JSON.parse(openTitleStr)
        openTitle.forEach((obj, index) => {
          // 在这里执行其他需要对每个对象执行的操作
          if (this.openId === obj.openId){
            title = obj.title;
          }
        });
        
        if (title) {
          document.title =  title
        }else {
          let auth = this.$createAuth(this.$md5);
          let result = await this.$http.get(this.$url.getTitle, {
            openId: this.openId,
            auth: auth.code,
            time: auth.time
          })
          if (result.message === 'Error: Miss auth parameter.') {
            this.getTitle();
          } else {
            title = result.data.title;
          }
          let objResult = {'openId': this.openId, 'title': title}
          openTitle.push(objResult)
          localStorage.setItem('openTitle', JSON.stringify(openTitle))
        }
      }else {
        let auth = this.$createAuth(this.$md5);
        let result = await this.$http.get(this.$url.getTitle, {
          openId: this.openId,
          auth: auth.code,
          time: auth.time
        })
        if (result.message === 'Error: Miss auth parameter.') {
          this.getTitle();
        } else {
          title = result.data.title;
        }
        let objResult = {'openId': this.openId, 'title': title}
        openTitle = []
        openTitle.push(objResult)
        localStorage.setItem('openTitle', JSON.stringify(openTitle))
      }
      document.title = title
    },
    goYsg() {
      if (this.$route.query.hospitalId) {
        this.$router.push(`/ysgInfo?openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}&type=1`);
      } else {
        this.$router.push(`/ysg?openId=${this.$route.query.openId}&type=1`);
      }
    },
    goQuery() {
      this.$router.push(`/query?openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}`);
    },
  },
};
</script>
<style scope lang="less">
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}

.plus {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;

  img {
    width: 0.5rem;
  }
}

.record {
  width: 100%;
  padding-bottom: 3rem;

  .record-list-item {
    display: flex;

    div {
      width: 25%;
      height: 1rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 1rem;
      border-right: 1px solid #eeeeee;
      border-bottom: 1px solid #dddddd;

      &.big-item {
        width: 50%;
      }
    }

    &:nth-child(odd) {
      background: #eeeeee;
    }
  }
}

.r-query {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2rem;
  line-height: 1rem;
  background: #fff;
  text-align: center;
}

.r-query .btn {
  width: 6.5rem;
  height: 1rem;
  margin: 0.4rem auto;
  color: #fff;
  border-radius: 5px;
  background: #5CC4AB;
}
</style>
